import React from "react";

const SectionHeading = ({ eyebrow, title, description, aside }) => (
  <div className="section-heading">
    <div className="section-heading-copy">
      {eyebrow && <p className="section-eyebrow">{eyebrow}</p>}
      <h2 className="section-title">{title}</h2>
      {description && <p className="section-description">{description}</p>}
    </div>
    {aside && <div className="section-aside">{aside}</div>}
  </div>
);

export default SectionHeading;
